module.exports = __webpack_public_path__ + "static/media/card-match.29881ff7.png";